import axios from "axios";
import { PUBLIC_URL } from "api/config";
var qs = require("qs");

export function loginIN(parameter) {
  const url = PUBLIC_URL + "account/login";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8"
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function saveUser(parameter) {
  const url = PUBLIC_URL + "user/saveUser";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function deleteUser(parameter) {
  const url = PUBLIC_URL + "member/deleteMember";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function freezeUser(parameter) {
  const url = PUBLIC_URL + "member/frozenMember";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllUser(parameter) {
  const url = PUBLIC_URL + "member/memberList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//会员列表里面查看已推荐人的列表数据接口
// export function getPushUser(parameter) {
//   const url = PUBLIC_URL + "user/getUserSubordinate?" + qs.stringify(parameter);
//   return axios
//     .get(url, {
//       parameter,
//       headers: {
//         "Content-Type": "application/json;charset=utf-8",
//         token: window.localStorage.getItem("token")
//       }
//     })
//     .then(res => {
//       return Promise.resolve(res.data);
//     });
// }
export function getPushUser(userId) {
  const param = {
    userId: userId
  };
  const url = PUBLIC_URL + "/member/uFans?" + qs.stringify(param);
  // const parameter = { userId };
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/*******************************供货商***************************/
export function addSupplier(parameter) {
  const url = PUBLIC_URL + "supplier/addSupplier";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function updateSupplier(parameter) {
  const url = PUBLIC_URL + "supplier/updateSupplier";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function deleteSupplier(parameter) {
  const url = PUBLIC_URL + "supplier/deleteSupplier";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllSupplier(parameter) {
  const url = PUBLIC_URL + "supplier/supplierList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getSupplierDetail(parameter) {
  const url = PUBLIC_URL + "supplier/supplierInfo?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getLogistics(parameter) {
  const url =
    PUBLIC_URL + "logistics/logisticsCompany?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************产品类型***************************/

export function addCategory(parameter) {
  const url = PUBLIC_URL + "category/addCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function updateCategory(parameter) {
  const url = PUBLIC_URL + "category/updateCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function deleteCategory(parameter) {
  const url = PUBLIC_URL + "category/deleteCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllCategory(parameter) {
  const url = PUBLIC_URL + "category/categoryList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getCategorys(parameter) {
  const url = PUBLIC_URL + "category/category";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************轮播图***************************/

export function addBanner(parameter) {
  const url = PUBLIC_URL + "banner/addBanner";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function updateBanner(parameter) {
  const url = PUBLIC_URL + "banner/updateBanner";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function deleteBanner(parameter) {
  const url = PUBLIC_URL + "banner/deleteBanner";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllBanner(parameter) {
  const url = PUBLIC_URL + "banner/bannerList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getBannerSpu(parameter) {
  const url = PUBLIC_URL + "banner/bannerSpu?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getBanneTitle(parameter) {
  const url = PUBLIC_URL + "banner/getBannerTitle";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function editBannerTitle(parameter) {
  const url = PUBLIC_URL + "banner/setBannerTitle";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************众筹***************************/

export function getAllRaise(parameter) {
  const url =
    PUBLIC_URL + "crowdfunding/getCrowdfundingList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function addRaise(parameter) {
  const url = PUBLIC_URL + "crowdfunding/addCrowdfunding";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function addRound(parameter) {
  const url = PUBLIC_URL + "crowdfunding/addCrowdfunding";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllProvince(parameter) {
  const url = PUBLIC_URL + "area/listByPcode?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************商品***************************/

export function getAllProduct(parameter) {
  const url = PUBLIC_URL + "product/productList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
//获取所有得规格
export function productSkuList(parameter) {
  let url = PUBLIC_URL + "product/productSkuList";
  if (parameter != undefined && parameter != null) {
    url = PUBLIC_URL + "product/productSkuList?type=" + parameter.type;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllProduct1(parameter) {
  const url = PUBLIC_URL + "product/allProduct?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function addProduct(parameter) {
  const url = PUBLIC_URL + "product/addProduct";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      },
      timeout: 20000
    })
    .then(res => {
      return Promise.resolve(res.data);
    })
    .catch(function(error) {
      return { status: 400, message: "请求超时，请重试！" };
    });
}

export function modifyStatus(parameter) {
  const url = PUBLIC_URL + "product/upAndDown";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function deleteProduct(parameter) {
  const url = PUBLIC_URL + "product/deleteProduct";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 添加商品里面的一个接口
export function getProductDetail(parameter) {
  const url = PUBLIC_URL + "product/productInfo?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function updateProduct(parameter) {
  const url = PUBLIC_URL + "product/updateProduct";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      },
      timeout: 20000
    })
    .then(res => {
      return Promise.resolve(res.data);
    })
    .catch(function(error) {
      return { status: 400, message: "请求超时，请重试！" };
    });
}

export function postRepeatPrice(parameter) {
  const url = PUBLIC_URL + "product/setRepetitionPrice";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllDirectSell(parameter) {
  const url = PUBLIC_URL + "product/directSelling?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getStoreAllProduct(parameter) {
  const url =
    PUBLIC_URL + "storeOrder/getStoreAllProduct?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function addDirectSell(parameter) {
  const url = PUBLIC_URL + "directSelling/addProduct";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 添加门店
export function addStoreWarehouse(parameter) {
  const url = PUBLIC_URL + "storeOrder/addStoreWarehouse";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 添加技师

export function deleteDirectSell(parameter) {
  const url = PUBLIC_URL + "directSelling/deleteProduct";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************订单***************************/

export function getAllOrders(parameter) {
  const url = PUBLIC_URL + "order/orderList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function dispatch(parameter) {
  const url = PUBLIC_URL + "order/dispatch";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function finishOrder(parameter) {
  const url = PUBLIC_URL + "order/finishOrder";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************财务***********充值****************/

export function getAllBalance(parameter) {
  const url = PUBLIC_URL + "balance/getRefillList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function agreeBalance(parameter) {
  const url = PUBLIC_URL + "/balance/refillAudit";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/*******************************财务************提现***************/
export function getAllBalance1(parameter) {
  const url =
    PUBLIC_URL + "wallet/getWithdrawDepositList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function oprateBalance1(parameter) {
  const url = PUBLIC_URL + "wallet/withdrawDepositAudit";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/************************************/
export function getSystem(parameter) {
  const url = PUBLIC_URL + "conf/getConfig";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function saveSystem(parameter) {
  const url = PUBLIC_URL + "conf/updateConfig";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function uploadFile(parameter) {
  const url = PUBLIC_URL + "file/upload";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************上传****************/
export function uploadFile1(parameter) {
  const url = PUBLIC_URL + "file/upload";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/********************上传****************/
export function uploadFile2(parameter) {
  const url = PUBLIC_URL + "file/upload";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************门店****************/
/********************门店--------------门店申请列表****************/
export function getStoreAuditList(parameter) {
  const url = PUBLIC_URL + "store/storeList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************门店--------------审核****************/
export function postStoreAudit(parameter) {
  const url = PUBLIC_URL + "store/check";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************门店--------------开启 或 关闭****************/
export function postStoreOpenClose(parameter) {
  const url = PUBLIC_URL + "store/openCloseStore";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/********************进销存门店--------------开启 或 关闭****************/
export function postSaleStoreOpenClose(parameter) {
  const url = PUBLIC_URL + "store/updateIsErp?" + qs.stringify(parameter);

  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/*******************导航栏商城--------------开启进入商城 或 关闭进入商城****************/

export function postSuperOpenClose(parameter) {
  const url = PUBLIC_URL + "category/update";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/*******************首页--------------开启进入商城 或 关闭进入商城****************/
export function postShouSuperOpenClose(parameter) {
  const url = PUBLIC_URL + "category/updateNew";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************门店--------------门店类型****************/
export function getStoreType(parameter) {
  const url = PUBLIC_URL + "store/storeTypeList";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************门店--------------获取门店分类****************/
export function getStoreCategory(parameter) {
  const url = PUBLIC_URL + "store/category";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************门店--------------门店列表****************/
export function getStoreList(parameter) {
  const url = PUBLIC_URL + "store/allStore";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************banner -------------- 获取轮播图绑定的门店信息****************/
export function getBannerStore(parameter) {
  const url = PUBLIC_URL + "banner/bannerStore?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/********************门店-----门店分类****************/
export function addStoreCategory(parameter) {
  const url = PUBLIC_URL + "storeCategory/addCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function updateStoreCategory(parameter) {
  const url = PUBLIC_URL + "storeCategory/updateCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function deleteStoreCategory(parameter) {
  const url = PUBLIC_URL + "storeCategory/deleteCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getStoreAllCategory(parameter) {
  const url =
    PUBLIC_URL + "storeCategory/categoryList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function uploadStoreImage(parameter) {
  const url = PUBLIC_URL + "store/setImage";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//-----------------------------财务统计-------------------------------
//-----门店提现
export function getFinanceStore(parameter) {
  const url = PUBLIC_URL + "store/storeWithdrawList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//-----门店提现 -- 审核
export function postFinanceStore(parameter) {
  const url = PUBLIC_URL + "/store/checkStoreWithdraw";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//-----新增获取用户优惠券转账记录接口
export function getFinanceCoupon(parameter) {
  const url = PUBLIC_URL + "member/cash-coupon-turn-record?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//-----新增用户账户变更记录接口
export function getFinanceAccountChange(parameter) {
  const url = PUBLIC_URL + "member/account-edit-record?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//-----消费礼包记录接口
export function getConsumptionRecord(parameter) {
  const url = PUBLIC_URL + "gp-record/consumption-list?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//-----消费礼包业务补贴记录接口
export function getBusinessSubsidiesRecord(parameter) {
  const url = PUBLIC_URL + "gp-record/business-subsidies-list?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function setAreaProduct(parameter) {
  const url = PUBLIC_URL + "banner/setAreaProduct";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getProductArea(parameter) {
  const url = PUBLIC_URL + "banner/getProductArea";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************门店相关***********************************/
export function getStoreDiscountList(parameter) {
  const url = PUBLIC_URL + "store/discountList";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 添加门店
export function addStore(parameter) {
  const url = PUBLIC_URL + "store/addStore";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}export function updateStore(parameter) {
  const url = PUBLIC_URL + "store/updateStore";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 添加技师
export function addTechnician(parameter) {
  const url = PUBLIC_URL + "Technician/addTechnician";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function updateStoreBanner(parameter) {
  const url = PUBLIC_URL + "store/updateBanner";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getStorePickOrderList(parameter) {
  const url =
    PUBLIC_URL + "storeOrder/pickOrderList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getStoreShortcutOrderList(parameter) {
  const url =
    PUBLIC_URL + "storeOrder/shortcutOrderList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getStoreServiceOrderList(parameter) {
  const url =
    PUBLIC_URL + "storeOrder/serviceOrderList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************统计相关***********************************/

export function homeData11(parameter) {
  const url = PUBLIC_URL + "home/data_1_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData12(parameter) {
  const url = PUBLIC_URL + "home/data_1_2";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData13(parameter) {
  const url = PUBLIC_URL + "home/data_1_3";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData21(parameter) {
  const url = PUBLIC_URL + "home/data_2_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData22(parameter) {
  const url = PUBLIC_URL + "home/data_2_2";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData31(parameter) {
  const url = PUBLIC_URL + "home/data_3_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData41(parameter) {
  const url = PUBLIC_URL + "home/data_4_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData51(parameter) {
  const url = PUBLIC_URL + "home/data_5_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData61(parameter) {
  const url = PUBLIC_URL + "home/data_6_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData71(parameter) {
  const url = PUBLIC_URL + "home/data_7_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData721(parameter) {
  const url = PUBLIC_URL + "home/data_7_2_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData722(parameter) {
  const url = PUBLIC_URL + "home/data_7_2_2?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData73(parameter) {
  const url = PUBLIC_URL + "home/data_7_3";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function homeData74(parameter) {
  const url = PUBLIC_URL + "home/data_7_4";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData75(parameter) {
  const url = PUBLIC_URL + "home/data_7_5";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData81(parameter) {
  const url = PUBLIC_URL + "home/data_8_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData91(parameter) {
  const url = PUBLIC_URL + "home/data_9_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData101(parameter) {
  const url = PUBLIC_URL + "home/data_10_1";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData111(parameter) {
  const url = PUBLIC_URL + "home/data_11_1?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function homeData112(parameter) {
  const url = PUBLIC_URL + "home/data_11_2?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function homeData113(parameter) {
  const url = PUBLIC_URL + "home/data_11_3?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function homeData114(parameter) {
  const url = PUBLIC_URL + "home/data_11_4?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function homeData121(parameter) {
  const url = PUBLIC_URL + "home/data_12_1?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function homeData122(parameter) {
  const url = PUBLIC_URL + "home/data_12_2?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function homeData123(parameter) {
  const url = PUBLIC_URL + "home/data_12_3?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function homeData124(parameter) {
  const url = PUBLIC_URL + "home/data_12_4?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/**
 * 获取红利统计数据
 * @param {*} parameter
 */
export function getBonusByTime(parameter) {
  const url = PUBLIC_URL + "account/getBonusByTime?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 表格信息
export function appManagerFunc(parameter) {
  const url =
    PUBLIC_URL + "appVersion/getAppVersionList?=" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 文件上传
export function appUploadFile(parameter) {
  const url = PUBLIC_URL + "file/upload";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 提交新增
export function confirmFunc(parameter) {
  const url = PUBLIC_URL + "appVersion/addAppVersion";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8"
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
//查询门店配送订单
export function selectDeliveryOrderList(parameter) {
  const url =
    PUBLIC_URL + "order/selectDeliveryOrderList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function getWithdrawDepositList(parameter) {
  const url =
    PUBLIC_URL + "withdraw/getWithdrawDepositList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 商品专区的选择列表
export function getPrefecture() {
  const url = PUBLIC_URL + "banner/bannerList?current=1&size=1000";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 关联品牌的选择列表
export function brandCategoryCategory() {
  const url = PUBLIC_URL + "BrandCategory/category";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function withdrawDepositAudit(parameter) {
  const url = PUBLIC_URL + "withdraw/withdrawDepositAudit";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function getSystemConf() {
  const url = PUBLIC_URL + "account/getSystemConf?current=1&size=1000";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function rechargeSurplusQt(parameter) {
  const url =
    PUBLIC_URL + "account/rechargeSurplusQt?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function editWithdrawRate(parameter) {
  const url =
    PUBLIC_URL + "account/editWithdrawRate?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function editTotalQt(parameter) {
  const url = PUBLIC_URL + "account/editTotalQt?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
export function editQtUnitRate(parameter) {
  const url = PUBLIC_URL + "account/editQtUnitRate?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 会员编辑功能
export function updateMemberById(parameter) {
  const url = PUBLIC_URL + "member/updateMemberById";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 首页视频
export function indexVideoSubmit(parameter) {
  const url = PUBLIC_URL + "video/upload-video";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 首页底部图片
export function indexBottomImgSubmit(parameter) {
  const url = PUBLIC_URL + "image/upload-bottom-image";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
//首页视频
export function getIndexVideo(parameter) {
  const url = PUBLIC_URL + "video/current-video";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
//首页底部图片
export function getBottomImg(parameter) {
  const url = PUBLIC_URL + "image/current-bottom-image";
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/*******************************品牌分类***************************/
// 添加品牌分类
export function addBrandCategoryCategory(parameter) {
  const url = PUBLIC_URL + "BrandCategory/addCategory";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
//修改品牌分类
export function updateCategoryBrandCategory(parameter) {
  const url = PUBLIC_URL + "BrandCategory/updateCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 删除品牌分类
export function deleteCategoryBrandCategory(parameter) {
  const url = PUBLIC_URL + "BrandCategory/deleteCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
/*******************************技师类型***************************/

export function addTechnicianCategory(parameter) {
  const url = PUBLIC_URL + "TechnicianCategory/addCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function updateTechnicianCategory(parameter) {
  const url = PUBLIC_URL + "TechnicianCategory/updateCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 删除技师分类
export function deleteTechnicianCategory(parameter) {
  const url = PUBLIC_URL + "TechnicianCategory/deleteCategory";

  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

export function getAllTechnicianCategory(parameter) {
  const url =
    PUBLIC_URL + "TechnicianCategory/categoryList?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

/*******************************计次商品单元***************************/
export function getGoodsUnitList(parameter) {
  const url = PUBLIC_URL + "goodsUnit/list?" + qs.stringify(parameter);
  return axios.get(url, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      token: window.localStorage.getItem("token")
    }
  }).then(res => {
    return Promise.resolve(res.data);
  });
}

export function checkGoodsUnit(parameter) {
  const url = PUBLIC_URL + "goodsUnit/check";
  return axios.post(url, parameter, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      token: window.localStorage.getItem("token")
    }
  }).then(res => {
    return Promise.resolve(res.data);
  });
}

/*******************************技师列表***************************/
export function getAllTechnician(parameter) {
  const url =
    PUBLIC_URL + "Technician/getAllTechnician?" + qs.stringify(parameter);
  return axios
    .get(url, {
      parameter,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 删除技师列表
export function deleteTechnician(parameter) {
  const url = PUBLIC_URL + "Technician/updateType?" + qs.stringify(parameter);
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })

    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 修改技师形象图
export function uploadTechnicianImage(parameter) {
  const url = PUBLIC_URL + "Technician/updatePhoto";
  return axios
    .post(url, parameter, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token: window.localStorage.getItem("token")
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

//
// export function getAllProduct1(parameter) {
//   const url = PUBLIC_URL + 'product/allProduct?' + qs.stringify(parameter)
//   return axios.get(url, {
//     parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=utf-8',
//       'token': window.localStorage.getItem("token")
//     }
//   }).then((res) => {
//     return Promise.resolve(res.data)
//   })
// }

export const homeData11Export = PUBLIC_URL + "home/data_1_1_export?";
export const homeData12Export = PUBLIC_URL + "home/data_1_2_export?";
export const homeData13Export = PUBLIC_URL + "home/data_1_3_export?";
export const homeData21Export = PUBLIC_URL + "home/data_2_1_export?";
export const homeData22Export = PUBLIC_URL + "home/data_2_2_export?";
export const homeData111Export = PUBLIC_URL + "home/data_11_1_export?";
export const homeData112Export = PUBLIC_URL + "home/data_11_2_export?";
export const homeData113Export = PUBLIC_URL + "home/data_11_3_export?";
export const homeData114Export = PUBLIC_URL + "home/data_11_4_export?";
export const homeData121Export = PUBLIC_URL + "home/data_12_1_export?";
export const homeData122Export = PUBLIC_URL + "home/data_12_2_export?";
export const homeData123Export = PUBLIC_URL + "home/data_12_3_export?";
export const homeData124Export = PUBLIC_URL + "home/data_12_4_export?";
export const bonusItemExport = PUBLIC_URL + "home/bonusItemExport?";
export const exportByOrderType = PUBLIC_URL + "home/exportByOrderType?";



// WEBPACK FOOTER //
// ./src/api/request.js